module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/30ft-mobile-66e0a3288327edd981fa60eff1b5331f.png";